import { I18nThemed } from 'interfaces/mixins';
import { DNode } from '@dojo/framework/core/interfaces';
import { v, w } from '@dojo/framework/core/vdom';
import { TextInput } from '@dojo/widgets/text-input';

import { a11yMap, formValueMap } from '../support/form-value-map';
import { FormStringField } from '../interfaces';

export interface FormStringProperties extends FormStringField {}

const skipmap = new Set<string>(Object.keys(formValueMap));
const a11ymap = new Set<string>(Object.keys(a11yMap));

export class FormString extends I18nThemed<FormStringProperties> {
	valid: boolean | undefined;

	protected render(): DNode {
		const { title: label, fgDefault, id: name, hidden, required, placeholder, formdata } = this.properties;
		if (formdata[name] === undefined || formdata[name] === null) {
			formdata[name] = fgDefault || '';
		}
		const value = formdata[name] || fgDefault || '';
		if (skipmap.has(name)) {
			formdata[name] = formValueMap[name];
			return null;
		}
		if (this.valid === undefined) {
			this.valid = !required;
		}

		const field = w(
			TextInput,
			{
				name,
				value,
				autocomplete: a11ymap.has(name) ? a11yMap[name] : '',
				required,
				placeholder,
				valid: this.valid,
				onValue: (value: string) => {
					formdata[name] = value;
					this.valid = (required && value.length > 1) || !required;
					this.invalidate();
				}
			},
			[{ label }]
		);

		if (hidden) {
			formdata[name] = value;
			return v('input', {
				id: name,
				name,
				value,
				hidden: ''
			});
		}
		return v('div', {}, [field]);
	}
}
